import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faFileWord as farFileWord,
  faFilePowerpoint as farFilePowerpoint,
  faFileExcel as farFileExcel,
  faFilePdf as farFilePdf,
  faFileVideo as farFileVideo,
  faFileAudio as farFileAudio,
  faFileCode as farFileCode,
  faFileLock as farFileLock,
  faFileShield as farFileShield,
  faFileCircleExclamation as farFileCircleExclamation,
  faFileImage as farFileImage,
  faFileArchive as farFileArchive,
  faFileAlt as farFileAlt,
  faEnvelope as farEnvelope,
  faFile as farFile,
  faTimesCircle as farTimesCircle,
  faTrashAlt as farTrashAlt,
  faCopy as farCopy,
  faFileExport as farFileExport,
  faFileEdit as farFileEdit,
  faTrash as farTrash,
  faShareAlt as farShareAlt,
  faEyeSlash as farEyeSlash,
  faFilePlus as farFilePlus,
  faFileImport as farFileImport,
  faFileUpload as farFileUpload,
  faEdit as farEdit,
  faClone as farClone,
  faTimes as farTimes,
  faSearch as farSearch,
  faExternalLink as farExternalLink,
  faDownload as farDownload,
  faUserTimes as farUserTimes,
  faArrowFromLeft as farArrowFromLeft,
  faDoNotEnter as farDoNotEnter,
  faCheck as farCheck,
  faClockRotateLeft as faClockRotateLeft,
  faMagnifyingGlass as farMagnifyingGlass,
  faXmark as farXmark,
  faEye as fasEye
} from "@fortawesome/pro-regular-svg-icons";

import {
  faFolder as fasFolder,
  faFolderPlus as fasFolderPlus,
  faDatabase as fasDatabase,
  faUsers as fasUsers,
  faSearch as fasSearch,
  faAngleLeft as fasAngleLeft,
  faAngleRight as fasAngleRight,
  faAngleDown as fasAngleDown,
  faCheck as fasCheck,
  faFileArchive as fasFileArchive,
  faLink as fasLink,
  faPlus as fasPlus,
  faInfoCircle as fasInfoCircle,
  faWrench as fasWrench,
  faStream as fasStream,
  faTh as fasTh,
  faBars as fasBars,
  faLock as fasLock,
  faTimes as fasTimes,
  faJ as fasJ,
  faTrash as fasTrash,
  faLockKeyholeOpen as fasLockKeyholeOpen,
  faLockKeyhole as fasLockKeyhole,
  faFile as fasFile,
  faFileCheck as fasFileCheck
} from "@fortawesome/pro-solid-svg-icons";

import {
  faFilePlus as falFilePlus,
  faFileImport as falFileImport,
  faFileUpload as falFileUpload,
  faCopy as falCopy,
  faFileExport as falFileExport,
  faFileEdit as falFileEdit,
  faTrash as falTrash,
  faShareAlt as falShareAlt,
  faEyeSlash as falEyeSlash,
  faTimes as falTimes,
  faSearch as falSearch,
  faSadTear as falSadTear,
  faEllipsisVertical as falEllipsisVertical,
  faPenToSquare as falPenToSquare
} from "@fortawesome/pro-light-svg-icons";

import {
  faAndroid as fabAndroid,
  faChrome as fabChrome,
  faApple as fabApple,
  faEdge as fabEdge,
  faWindows as fabWindows
} from "@fortawesome/free-brands-svg-icons";

export default {
  initFontAwesome() {
    // Regular
    library.add(
      farEyeSlash,
      farFileWord,
      farFilePowerpoint,
      farFileExcel,
      farFilePdf,
      farFileVideo,
      farFileAudio,
      farFileCode,
      farFileLock,
      farFileShield,
      farFileCircleExclamation,
      farFileImage,
      farFileArchive,
      farFileAlt,
      farEnvelope,
      farFile,
      farTimesCircle,
      farTrashAlt,
      farCopy,
      farFileExport,
      farFileEdit,
      farTrash,
      farShareAlt,
      farFilePlus,
      farFileImport,
      farFileUpload,
      farEdit,
      farClone,
      farTimes,
      farSearch,
      farExternalLink,
      farDownload,
      farUserTimes,
      farArrowFromLeft,
      farDoNotEnter,
      farCheck,
      faClockRotateLeft,
      farMagnifyingGlass,
      farXmark
    );

    // Solid
    library.add(
      fasFolder,
      fasFolderPlus,
      fasDatabase,
      fasUsers,
      fasSearch,
      fasAngleLeft,
      fasAngleRight,
      fasAngleDown,
      fasCheck,
      fasFileArchive,
      fasLink,
      fasPlus,
      fasInfoCircle,
      fasWrench,
      fasStream,
      fasTh,
      fasBars,
      fasLock,
      fasTimes,
      fasJ,
      fasTrash,
      fasLockKeyholeOpen,
      fasLockKeyhole,
      fasFile,
      fasFileCheck,
      fasEye
    );

    // Light
    library.add(
      falFilePlus,
      falFileImport,
      falFileUpload,
      falCopy,
      falFileExport,
      falFileEdit,
      falTrash,
      falShareAlt,
      falEyeSlash,
      falTimes,
      falSearch,
      falSadTear,
      falEllipsisVertical,
      falPenToSquare
    );

    library.add(fabAndroid, fabChrome, fabApple, fabEdge, fabWindows);
  }
};
